import { CovCard } from "@cx-component-library/react-components";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Button, Grid } from "@mui/material";
import { UnauthenticationDialog } from "components/dialog/UnauthenticationDialog";
import React from "react";

interface landingPageCard {
  boxName?: string;
  bgImage?: string;
  boxColorBg?: string;
  boxContentTitle?: string;
  boxContentText?: string;
  numOfColumns?: number;
  btnActionName?: string;
  urlAction?: string;
  isLogin: boolean;
}

export const LandingPageCard = ({
  boxName,
  boxColorBg,
  boxContentTitle,
  boxContentText,
  numOfColumns = 1,
  btnActionName,
  urlAction = "",
  isLogin = false,
}: landingPageCard) => {
  const [openCheckAuth, setOpenCheckAuth] = React.useState(false);
  const handleNavigate = () => {
    if (urlAction && urlAction.length > 0) {
      if (urlAction.includes("/search?") && !isLogin) {
        setOpenCheckAuth(true);
      } else {
        window.open(urlAction);
      }
    }
  };
  return (
    <Grid size={numOfColumns} marginTop={"13px"} height={"158px"}>
      <CovCard
        actions={
          urlAction &&
          urlAction.length > 0 && (
            <Button
              onClick={handleNavigate}
              sx={{
                border: "0px",
                "&:hover": { border: "0px" },
                padding: 0,
                height: "auto",
                whiteSpace: "nowrap",
              }}
              variant="outlined"
              endIcon={<OpenInNewIcon />}
            >
              {btnActionName}
            </Button>
          )
        }
        header={boxContentTitle}
        tagline={boxName}
        covTagProps={{
          sx: {
            backgroundColor: `${boxColorBg} !important`,
            ".MuiChip-label": {
              letterSpacing: "0.8px",
            },
          },
        }}
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          "& .cov-card__header-text": {
            height: "48px",
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            textOverflow: "ellipsis",
          },
          "& .cov-card__content": {
            height: "40px",
            overflow: "hidden",
          },
        }}
      >
        <p
          style={{
            color: "#4D4D4D",
            margin: 0,
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            textOverflow: "ellipsis",
          }}
        >
          {boxContentText}
        </p>
      </CovCard>
      <UnauthenticationDialog
        isOpen={openCheckAuth}
        onClose={setOpenCheckAuth}
      />
    </Grid>
  );
};
